import { render, staticRenderFns } from "./popBatchEdit.vue?vue&type=template&id=6ad452a6&scoped=true"
import script from "./popBatchEdit.vue?vue&type=script&lang=js"
export * from "./popBatchEdit.vue?vue&type=script&lang=js"
import style0 from "./popBatchEdit.vue?vue&type=style&index=0&id=6ad452a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad452a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad452a6')) {
      api.createRecord('6ad452a6', component.options)
    } else {
      api.reload('6ad452a6', component.options)
    }
    module.hot.accept("./popBatchEdit.vue?vue&type=template&id=6ad452a6&scoped=true", function () {
      api.rerender('6ad452a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/popBatchEdit.vue"
export default component.exports